(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    // Subscribe / one-time toggle.
  //
  // The bundle selector renders its own <form> for Horizon's variant-picker
  // contract, but the real add-to-cart form belongs to a different block. So
  // the selling_plan input has to be injected into THAT form, not this one.
  //
  // The input carries `disabled` when one-time is selected. A disabled input is
  // not submitted at all, which is exactly what a one-time purchase needs —
  // clearing the value alone still submits an empty selling_plan.
  (function () {
    function init(root) {
      if (root.dataset.msModeReady === '1') return;
      var tabs = root.querySelectorAll('[data-set-mode]');
      if (!tabs.length) return;
      root.dataset.msModeReady = '1';

      var mode = window.__msBundleMode || 'sub';

      // Reflect the remembered mode on the freshly rendered tabs, which the
      // server always ships with Subscribe active.
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-set-mode') === mode;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      function cartForm() {
        var section = root.closest('.shopify-section, [id^="shopify-section"]') || document;
        return section.querySelector('form[action*="/cart/add"]')
          || document.querySelector('form[action*="/cart/add"]');
      }

      function planInput() {
        var form = cartForm();
        if (!form) return null;
        // Seal injects its own selling_plan input. Two inputs of the same name means
        // FormData submits whichever comes first in the DOM — Seal's, which is empty.
        // So adopt the existing one rather than adding a rival, and only create one
        // if Seal has not put anything there.
        var input = form.querySelector('input[name="selling_plan"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          form.appendChild(input);
        }
        input.setAttribute('data-ms-plan', '');

        // Any extra selling_plan inputs are removed so exactly one is ever submitted.
        form.querySelectorAll('input[name="selling_plan"]').forEach(function (other) {
          if (other !== input) other.remove();
        });
        return input;
      }

      // Horizon builds the add-to-cart form in a sibling block, and may finish
      // after this one. Without this retry the very first Add to Cart submits no
      // selling plan at all: the shopper sees subscription pricing, is charged the
      // one-time price, and no subscription is created.
      function whenFormReady(cb) {
        if (cartForm()) return cb();
        var tries = 0;
        var timer = setInterval(function () {
          if (cartForm() || ++tries > 40) {
            clearInterval(timer);
            cb();
          }
        }, 100);
      }

      function selectedTier() {
        var checked = root.querySelector('.bundle-tier input[type="radio"]:checked');
        return checked ? checked.closest('.bundle-tier') : root.querySelector('.bundle-tier');
      }

      function sync() {
        // The page can hold two selectors (top buy box and a repeat further
        // down), and a click on Add to cart syncs both. Reading the shared mode
        // keeps the second one from reverting the page to its own stale mode.
        mode = window.__msBundleMode || mode;
        root.setAttribute('data-mode', mode);

        root.querySelectorAll('[data-set-mode]').forEach(function (t) {
          var on = t.getAttribute('data-set-mode') === mode;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        var tier = selectedTier();
        if (!tier) return;

        // Figures for both modes are in the markup; CSS keyed off this <html>
        // attribute shows the active set. It lives outside the block, so
        // Horizon's re-render on tier change can't reset it mid-paint.
        var isSub = mode === 'sub';
        document.documentElement.setAttribute('data-ms-bundle-mode', mode);

        var input = planInput();
        if (!input) return;
        var planId = tier.dataset.planId;
        if (isSub && planId) {
          input.value = planId;
          input.disabled = false;
        } else {
          input.value = '';
          input.disabled = true;
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          mode = tab.getAttribute('data-set-mode');
          window.__msBundleMode = mode;
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          sync();
        });
      });

      // Changing tier must re-point the plan, or the cart keeps the previous
      // tier's plan ID — the classic failure in this pattern.
      root.addEventListener('change', function (e) {
        if (e.target.matches('input[type="radio"]')) sync();
      });

      whenFormReady(sync);

      // Horizon re-renders the add-to-cart form after we append to it, which throws
      // our hidden input away. Rather than race that, re-assert it in the capture
      // phase of any click on the form — before Horizon reads the form data. This is
      // the line that guarantees the first Add to Cart carries the selling plan.
      document.addEventListener('click', function (e) {
        var form = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
        if (form) sync();
      }, true);

      // Horizon re-renders this block when the variant changes, which discards the
      // swapped prices. Re-apply after its update settles.
      document.addEventListener('variant:update', function () { setTimeout(sync, 50); });
      window.addEventListener('load', function () { setTimeout(sync, 100); });
    }

    function boot() {
      document.querySelectorAll('.bundle-selector').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);


    // Horizon swaps this block out and back in when the variant changes. The
    // replacement is a fresh element with no init flag, so without this it renders
    // an empty frequency picker and no selling plan. Debounced because boot() is
    // cheap but the mutation stream is not.
    var rebootTimer = null;
    new MutationObserver(function () {
      clearTimeout(rebootTimer);
      rebootTimer = setTimeout(boot, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
